import { render } from "./SocialMedia.html?vue&type=template&id=7cbc806c&scoped=true&ts=true&external"
import script from "./SocialMedia.ts?vue&type=script&lang=ts&external"
export * from "./SocialMedia.ts?vue&type=script&lang=ts&external"

import "./SocialMedia.scss?vue&type=style&index=0&id=7cbc806c&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbc806c"]])

export default __exports__